import { apiClient } from "./api";

export interface MarketplaceListing {
  id: string;
  type: "app" | "component" | "template";
  name: string;
  description: string;
  price: number;
  currency: string;
  payload: Record<string, unknown>;
  status: string;
  seller_id: string;
  created_at: string;
}

export async function listListings(type?: string): Promise<MarketplaceListing[]> {
  const response = await apiClient.get("/marketplace/listings", { params: type ? { type } : {} });
  return response.data as MarketplaceListing[];
}

export async function publishListing(
  listing: Omit<MarketplaceListing, "id" | "seller_id" | "created_at" | "status">,
): Promise<MarketplaceListing> {
  const response = await apiClient.post("/marketplace/listings", listing);
  return response.data as MarketplaceListing;
}

export async function getListing(id: string): Promise<MarketplaceListing> {
  const response = await apiClient.get(`/marketplace/listings/${id}`);
  return response.data as MarketplaceListing;
}
